import React, { ChangeEvent } from "react";
import { CMAScore, FormSectionElements, ProgramContainer } from "src/entities/formTemplateDataType";
import FormValidationUtils from "../../../utilities/FormValidationUtils";
import { HintExpansionComponent } from "../../odsCalloutBox/HintExpansionComponent";
import { getParentSection, getRootComponent } from "../../../utilities/ElementUtils";
import { getCategoryFromFunction, getCurrentFunction, getCurrentFunctions, getSelectedCategroy, setComments } from "../../../utilities/custom/CmaUtils";
import { TemplateStatus } from "../../../entities/Constants";


interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {

}

export class CMAQuestionComponent extends React.Component<Props, State> {

    HtmlToReactParser = require('html-to-react').Parser;
    constructor(props: Props) {
        super(props);

        let field = this.props.field;
        FormValidationUtils.runJavascript(field);

    }

    componentDidMount(): void {
        this.updateHeaderConfig(true);
    }

    componentWillUnmount(): void {
        this.updateHeaderConfig(false);
    }

    updateHeaderConfig = (comments: boolean) => {
        const root = getRootComponent(this.props.field);
        if (root.HeaderConfig?.comments !== comments) {
            if (comments) {
                const func = getCurrentFunction(root, this.props.field.LoadBindName);
                const category = getCategoryFromFunction(this.props.field.LoadBindName, func);
                root.HeaderConfig = {...root.HeaderConfig ?? {}, category: category.CategoryName, func: func.FunctionName};
            }
            root.HeaderConfig = {...root.HeaderConfig ?? {}, comments: comments};
            this.props.callbackElement(root);
        }
    }

    getGaTrackingId = () => {
        let section = this.props.field.parent;
        let trackingId = '';
        while (section && !section.GATrackingID) {
            section = section.parent;
        }

        return section?.GATrackingID;
    }

    onTextEditChange = (e) => {
        let field = this.props.field;
        let elem = e.originalEvent ? e.originalEvent.target : e.target;
        let val = elem.value;
        field.CMAQuestionComment = val;    
    
        elem.style.height = 'auto';
        elem.style.height = elem.scrollHeight + 'px';

        if(e.target.value.split(/[\s]+/).length <= 2000){
            document.getElementById("err"+field.LoadBindName).classList.add('ontario-error__hidden');
            document.getElementById(field.LoadBindName).classList.remove('ontario-input__error');
            document.getElementById(field.LoadBindName).setAttribute('aria-invalid', 'false');
            document.getElementById(field.LoadBindName).removeAttribute("maxLength")
        } else {
            document.getElementById(field.LoadBindName).setAttribute("maxLength", val.length);
            document.getElementById("err"+field.LoadBindName).classList.remove('ontario-error__hidden');
            document.getElementById(field.LoadBindName).classList.add('ontario-input__error');
            document.getElementById(field.LoadBindName).setAttribute('aria-invalid', 'true');
            document.getElementById(field.LoadBindName).setAttribute('aria-describedBy', `${"err"+field.LoadBindName}`);
        } 
        this.props.callbackElement(field.parent.parent.parent);
    }


    setSelectedRadio = (e: ChangeEvent<HTMLInputElement>, CMAvalue: CMAScore) => {
        let field = this.props.field;
        field.Value = CMAvalue;

        this.props.callbackElement(field.parent.parent.parent);
    }

    generateLabel = () => {
        const field = this.props.field;
        let labelControlArray = [];
        const title = this.props.isEng ? field.ENUTitle : field.FRATitle;
        const requireLabel = this.props.isEng ? "(required)" : "(obligatoire)";
        const root = this.props.field.parent.parent.parent as ProgramContainer;
        const useAsterisks = root.UseAsterisks == "Y";
        // if (field.Optional == "N") {
            labelControlArray.push(
                <div key={'fdLbl_' + field.Id}>
                    {(
                        <h1 className="ontario-label" tabIndex={-1} id={`label_${field.LoadBindName}`}>
                            {title}<span className="ontario-label__flag">{useAsterisks ? <span style={{ color: 'red' }}>*</span> : <span className='ontario-label__flag'>
                                {title ? requireLabel : null}</span>}
                            </span>
                            {field.TooltipENU && (<i role='tooltip' title={field.TooltipENU} className="pi pi-info-circle"></i>)}
                        </h1>
                    )}

                </div>);
        // } else {
        //     labelControlArray.push(
        //         <div key={'fdLbl_' + field.Id}>
        //             <div className="ontario-label" >{title} <span className="ontario-label__flag">{this.props.isEng ? "(optional)" : "(facultatif)"}</span>
        //                 {field.enuToolTip ? <i title={field.TooltipENU} className="pi pi-info-circle"></i> : null}
        //             </div>
        //         </div>);
        // }
        return labelControlArray;
    }

    render() {
        const field = this.props.field;
        const root = this.props.field.parent.parent.parent as ProgramContainer;
        const cmaRole = root.userRole?.split(',')?.reduce((finalRole, role) => finalRole === 'A' ? finalRole : role.charAt(0), '');
        FormValidationUtils.runJavascript(field);
        if (!field.Visible) return null;

        const htmlToReactParser = new this.HtmlToReactParser();

        let editable = field.Editable=='Y' && cmaRole != 'A' && root.Entity.status != TemplateStatus.SUBMITTED;

        let requiredField = this.props.requiredField;
        let controlArray = [];
        let title = this.props.title;

        // if (editable) {
            const hintHtml = this.props.isEng ? field.Hint : field.HintFR;
            let hint;
            if (field.Hint || field.HintFR) {
                hint = htmlToReactParser.parse(hintHtml);
            }
            controlArray.push(
                <>
                    {hint && <>{this.generateLabel()}</>}
                    <fieldset className='ontario-margin-top-24-!' key={`${field.LoadBindName}_${field.Sequence}`}>
                        {!hint && <legend>{this.generateLabel()}</legend>}
                        {hint && <legend><div className="ontario-hint">{hint}</div></legend>}
                        {field.hintExpansionTitle && editable && field.Visible && <HintExpansionComponent
                            isEng={this.props.isEng}
                            calloutType={field.callOutBoxType}
                            Visible={field.Visible}
                            bodyMsg={this.props.isEng?  field.callOutBoxBody:field.callOutBoxBodyFRA}
                            title={this.props.isEng? field.callOutBoxTitle:field.callOutBoxTitleFRA}
                            hintExpansionTitle={this.props.isEng? field.hintExpansionTitle:field.hintExpansionTitleFRA}
                            field={field}
                        ></HintExpansionComponent>
                        }
      
    
                        {root.CMAOptionList.map(val => {
                            return(
                                <div className="ontario-radios__item" >
                                    <input id={field.LoadBindName + val?.label?.replace(/[^a-zA-Z]/g, '')}
                                        onChange={(e) => this.setSelectedRadio(e, val)}
                                        className="ontario-radios__input"
                                        type="radio"
                                        aria-labelledby={`label_${field.LoadBindName}`}
                                        value={val.label}
                                        name={field.LoadBindName}
                                        checked={this.props.field.Value?.label == val?.label}
                                        disabled={!editable}
                                    />
                                    <label htmlFor={field.LoadBindName + val.label?.replace(/[^a-zA-Z]/g, '')} id={field.LoadBindName + val.label?.replace(/[^a-zA-Z]/g, '') + "_label"}
                                        className="ontario-label ontario-radios__label"
                                        title={val.toolTip}>
                                        {this.props.isEng ? val.label : val.labelFRA}
                                    </label>
                                </div>
                            )
                        })}
                        <div style={{ marginTop: '29px' }}>                        
                            <div id={"err"+field.LoadBindName} className="ontario-error-messaging ontario-error__hidden" role="alert">
                            <span className="ontario-error-messaging__icon">
                                <svg className="ontario-icon"  aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                    <use href="#ontario-icon-alert-error"></use>
                                    </svg>
                                    </span>
                                    <span role="alert" className="ontario-error-messaging__content">The maximum word limit is 2000</span>
                                    </div>
                            <textarea 
                                style={{ display: field.Visible ? 'block' : 'none', color: field.ReadOnly || cmaRole == 'A' ? 'color.palette.greyscale40' : 'color.palette.black', resize: "none"
                                    , overflow: "hidden" 
                                }}
                                rows={1}
                                role="textbox"
                                id={field.LoadBindName}
                                key={'fdIpt_' + field.LoadBindName}
                                className="ontario-input"
                                required={requiredField}
                                value={field.CMAQuestionComment}
                                readOnly={field.ReadOnly || cmaRole == 'A' || root.Entity.status == TemplateStatus.SUBMITTED}
                                placeholder='Text input placeholder'
                                aria-describedBy="" aria-invalid="false"
                                onChange={this.onTextEditChange}>
                            </textarea>
                        </div>
                    </fieldset>
                </>
            );
        // } else {
        //     controlArray.push(
        //         <div className='pdf-two-column'>
        //             <div>{title}<br></br>{htmlToReactParser.parse(this.props.field.Hint)}</div>
        //             <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })}>{field.Value}</div>
        //         </div>
        //     );
        // }

        return controlArray;

    }

}